// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';
import { v1ForbiddenErrorSchema } from './v1/forbiddenErrorSchema';
import { v1NotFoundErrorSchema } from './v1/notFoundErrorSchema';
import { v1TeamSchema } from './v1/teamSchema';
import { v1TeamsPatchSchema } from './v1/teams/patchSchema';
import { v1UnprocessableEntityErrorSchema } from './v1/unprocessableEntityErrorSchema';

export const patch11AccountIdTeamsIdPathParamsSchema = z.object({
  account_id: z.number().int().describe("Account ID for the team you want to patch"),
  id: z.number().int().describe("Team ID to patch"),
});

export const patch11AccountIdTeamsIdQueryParamsSchema = z.object({
  add_users_to_team_projects: z.optional(z.boolean().describe("Whether to add users to team projects")),
  delete_users_from_team_projects: z.optional(z.boolean().describe("Whether to delete users from team projects")),
}).optional();

export const patch11AccountIdTeamsIdHeaderParamsSchema = z.object({
  Authorization: z.optional(z.coerce.string()),
});

/**
 * @description Team details
 */
export const patch11AccountIdTeamsId200Schema = z.lazy(() => v1TeamSchema);

/**
 * @description Forbidden - Insufficient permissions to update team
 */
export const patch11AccountIdTeamsId403Schema = z.lazy(() => v1ForbiddenErrorSchema);

/**
 * @description Team not found
 */
export const patch11AccountIdTeamsId404Schema = z.lazy(() => v1NotFoundErrorSchema);

/**
 * @description Unprocessable Entity
 */
export const patch11AccountIdTeamsId422Schema = z.lazy(() => v1UnprocessableEntityErrorSchema);

export const patch11AccountIdTeamsIdMutationRequestSchema = z.lazy(() => v1TeamsPatchSchema);

export const patch11AccountIdTeamsIdMutationResponseSchema = z.lazy(() => patch11AccountIdTeamsId200Schema);
